import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AccountNameUpdateUI from './AccountNameUpdateUI.js'

class AccountNameUpdateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: [],
      accountName: this.props.accountName,
      accountNameError: null,
      submitted: false,
    }
  }

  render() {
    return (
      <AccountNameUpdateUI
        context={this.props.context}
        messageList={this.props.messageList}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        // accountName
        accountName={this.state.accountName}
        accountNameError={this.state.accountNameError}
        onAccountNameChange={this.onAccountNameChange}
        setAccountNameError={this.setAccountNameError}
        // form events
        onSubmit={this.onSubmit}
        onCancel={this.props.onCancel} // added in ViewOrUpdateUI
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
      />
    )
  }

  UNSAFE_componentWillMount() {
  }

  onAccountNameChange = (event) => {
    this.setState({accountName: event.target.value})
  }

  setAccountNameError = (error) => {
    this.setState({accountNameError: error})
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    console.log('calling server')
    this.setState({submitted: true})
    RestApiUtils.put(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/name`,
      this.onSubmitCallback, {
        accountName: this.state.accountName,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    this.setState({submitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'accountName':
            this.setAccountNameError(error.message)
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({successMsg: response.success})

    if (errorList.length === 0) {
      this.props.onUpdateComplete(this.state.accountName)
      setTimeout(() => {
        this.props.onCancel()
      }, 2000);
    }
  }
}

export default AccountNameUpdateSF
